Belimo.Downloadfolder = {
    update(documents) {
        $(document).trigger('downloadfolder-update', [documents]);
    },

    submit(url, data, callback) {
        $.ajax({
            method: 'POST',
            url,
            dataType: 'json',
            data,
            success(response) {
                if (response.errorMessage && response.errorMessage.length) {
                    Belimo.Modal.open(response.errorMessage, []);
                } else {
                    Belimo.Downloadfolder.update(response.entries || []);
                    if (callback) {
                        callback();
                    }
                }
            }
        });
    }
};
